import React from "react";
import {
  Button,
  Container,
  HStack,
  Icon,
  useBoolean,
  VStack,
} from "@chakra-ui/react";
import Logo from "components/Logo";
import { getShortenedAddress } from "utils/walletUtils";
import useConnectedAccount from "hooks/useConnectedAccount";
import WalletPopup from "components/WalletPopup";
import { Link } from "react-router-dom";
import WalletAssetsContainer from "containers/WalletAssetsContainer";
import MainMenu from "components/MainMenu";
import IncentivesPopup from "components/IncentivesPopup";
import { FaGift } from "react-icons/fa";
import Panel from "components/Panel";
import useTranslate from "hooks/useTranslate";
import { featureFlags } from "config";

const Header: React.FC = () => {
  const translate = useTranslate();
  const [address] = useConnectedAccount();
  const [isWalletDialogVisible, setIsWalletDialogVisible] = useBoolean();
  const [isIncentivesPopupOpen, setIsIncentivesPopupOpen] = useBoolean(false);

  return (
    <>
      <Panel as="header" px="0" pt="6" pb="0">
        <Container>
          <VStack align="stretch" spacing="6">
            <HStack overflow="hidden" spacing="3">
              <Link to="/">
                <Logo width="100%" height="auto" style={{ maxWidth: "9rem" }} />
              </Link>

              <HStack justify="flex-end" w="full" spacing="3">
                <Button
                  flex="none"
                  color="bright.50"
                  borderColor="dark.500"
                  _hover={{
                    borderColor: "primary.500",
                  }}
                  borderStyle="dashed"
                  colorScheme="bright"
                  borderRadius="full"
                  variant="outline"
                  size="sm"
                  ml="100%"
                  leftIcon={<Icon as={FaGift} color="primary.500" />}
                  onClick={setIsIncentivesPopupOpen.on}
                >
                  {translate("common:incentives")}
                </Button>

                {address && (
                  <Button
                    flex="none"
                    color="bright.50"
                    borderColor="dark.500"
                    _hover={{
                      borderColor: "primary.500",
                    }}
                    colorScheme="bright"
                    borderRadius="full"
                    variant="outline"
                    size="sm"
                    onClick={setIsWalletDialogVisible.on}
                  >
                    {getShortenedAddress(address, 3)}
                  </Button>
                )}
              </HStack>
            </HStack>

            <VStack
              spacing="3"
              w="full"
              align="stretch"
              pb={featureFlags.traitsSwapping ? "0" : "6"}
            >
              <WalletAssetsContainer />
              {featureFlags.traitsSwapping ? <MainMenu /> : null}
            </VStack>
          </VStack>
        </Container>
      </Panel>

      {isWalletDialogVisible && (
        <WalletPopup isOpen onClose={setIsWalletDialogVisible.off} />
      )}

      {isIncentivesPopupOpen && (
        <IncentivesPopup
          isOpen
          onClose={() => setIsIncentivesPopupOpen.off()}
        />
      )}
    </>
  );
};

export default Header;
